module.exports = __webpack_public_path__ + "img/nose_female_average.6b81a0d8.png";